module.exports = __webpack_public_path__ + "img/VE.e21e0b23.png";